<template>
  <div>
    <el-dropdown trigger="click" @command="handleSetSize">
      <div class="size-icon--style ">
        <svg-icon class-name="size-icon" icon-class="size"/>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="item of sizeOptions" :key="item.value" :disabled="size === item.value"
                            :command="item.value">
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import useAppStore from '@/store/modules/app'

const appStore = useAppStore()
const size = computed(() => appStore.size)
const route = useRoute()
const router = useRouter()
const {proxy} = getCurrentInstance()
const sizeOptions = ref([
  {label: '较大', value: 'large'},
  {label: '默认', value: 'default'},
  {label: '稍小', value: 'small'}
])

function handleSetSize(size) {
  proxy.$modal.loading('正在设置布局大小，请稍候...')
  appStore.setSize(size)
  setTimeout('window.location.reload()', 1000)
}
</script>

<style lang='scss' scoped>
.size-icon--style {
  font-size: var(--icon-size);
  line-height: var(--icon-width);
  width: var(--icon-width);
  .size-icon{
    transition: all 0.4s cubic-bezier(.22, 1, .36, 1);
    transform-origin: center center;
  }
  &:hover{
    .size-icon{
      transform: scale(1.15);
      color: #1890ff;
      animation: font-icon-bounce 0.6s ease-in-out infinite;
    }
  }
}

/* 加一点微弱的“呼吸”抖动，暗示可拖动/可调节 */
@keyframes font-icon-bounce {
  0%, 100% { transform: scale(1.15) translateY(0); }
  50%      { transform: scale(1.15) translateY(-2px); }
}
</style>
